import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Navbar from '../NavBar/Navbar';
import { ClientsFetchAPI } from '../../api/Clients';
import './client.css';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';


/* ── ICONS ── */
const IcoSearch = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IcoUsers = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
const IcoX = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoArrow = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>;
const IcoStar = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>;
const IcoPlus = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>;
const IcoMinus = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12" /></svg>;
const IcoHistory = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-4" /></svg>;
const IcoClock = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const IcoMail = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>;

const IcoChevL = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6" /></svg>;
const IcoChevR = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>;
const IcoChevsL = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="11 17 6 12 11 7" /><polyline points="18 17 13 12 18 7" /></svg>;
const IcoChevsR = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="13 17 18 12 13 7" /><polyline points="6 17 11 12 6 7" /></svg>;
const getInitials = (name = '') =>
    name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();

const txVariant = (type = '') => {
    const t = type.toLowerCase();
    if (t.includes('earn') || t.includes('redeem') === false && t.includes('add')) return 'earn';
    if (t.includes('redeem') || t.includes('use') || t.includes('spent')) return 'redeem';
    return 'other';
};

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
════════════════════════════════════════════════════════ */
const Clients = () => {




    /* ════════════════════════════════════
      
    ════════════════════════════════════ */
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [clientTransactions, setClientTransactions] = useState([]);

    let token = localStorage.getItem('x-access-token');
    let user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => { getBusinessClients(); }, []);

    const getBusinessClients = async () => {
        try {
            const res = await ClientsFetchAPI.getClientsByBusiness(user.business.id, token);
            setClients(res.data.data);
        } catch (error) { setClients([]); }
    };

    const handleClientDetails = (client) => {
        setSelectedClient(client);
        getClientPointsTransactions(client.id);
        setShowModal(true);
    };

    const getClientPointsTransactions = async (clientId) => {
        try {
            const res = await ClientsFetchAPI.getFrecuentShopperPointsTransactions(clientId, token);
            setClientTransactions(
                res.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            );
        } catch (error) { setClientTransactions([]); }
    };
    /* ════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ════════════════════════════════════ */

    /* search UI state (no afecta la lógica, solo filtra visualmente) */
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const filtered = clients.filter(c => {
        const q = search.toLowerCase();
        return !q || c.name?.toLowerCase().includes(q) || c.nickname?.toLowerCase().includes(q) || c.email?.toLowerCase().includes(q);
    });

    /* reset page when search or pageSize changes */
    useEffect(() => { setCurrentPage(1); }, [search, pageSize]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    const safePage = Math.min(currentPage, totalPages);
    const paginated = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

    /* page number buttons — show at most 5, with ellipsis */
    const pageNumbers = (() => {
        if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1);
        if (safePage <= 3) return [1, 2, 3, 4, '…', totalPages];
        if (safePage >= totalPages - 2) return [1, '…', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        return [1, '…', safePage - 1, safePage, safePage + 1, '…', totalPages];
    })();

    /* ── ESC closes modal ── */
    useEffect(() => {
        if (!showModal) return;
        const fn = e => { if (e.key === 'Escape') setShowModal(false); };
        document.addEventListener('keydown', fn);
        return () => document.removeEventListener('keydown', fn);
    }, [showModal]);

    /* ── body scroll lock ── */
    useEffect(() => {
        document.body.style.overflow = showModal ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [showModal]);

    /* ══════════════════════════════════
       RENDER
    ══════════════════════════════════ */
    return (
        <>
            <AppShell route="clients">
                <MainContent>
                    <div className="cl-page">

                        {/* ── PAGE HEADER ── */}
                        <div className="cl-page-header">
                            <div>
                                <p className="cl-page-eyebrow">Gestión</p>
                                <h1 className="cl-page-title">Clientes</h1>
                                <p className="cl-page-sub">Historial de puntos y transacciones por cliente</p>
                            </div>
                            <div className="cl-search">
                                <IcoSearch />
                                <input
                                    type="text"
                                    placeholder="Buscar cliente..."
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* ── TABLE CARD ── */}
                        <div className="cl-card">

                            <div className="cl-card-header">
                                <span className="cl-card-title">
                                    <IcoUsers /> Clientes Registrados
                                    <span className="cl-count-badge">{filtered.length}</span>
                                </span>
                            </div>

                            {/* ── TABLA — desktop ── */}
                            <div className="cl-table-wrap">
                                {filtered.length === 0 ? (
                                    <div className="cl-empty">
                                        <div className="cl-empty-icon">👤</div>
                                        <p className="cl-empty-title">
                                            {search ? 'Sin resultados' : 'Sin clientes registrados'}
                                        </p>
                                        <p className="cl-empty-sub">
                                            {search ? `No hay clientes que coincidan con "${search}".` : 'Aún no hay clientes en este negocio.'}
                                        </p>
                                    </div>
                                ) : (
                                    <table className="cl-table">
                                        <thead>
                                            <tr>
                                                <th>Cliente</th>
                                                <th>Usuario</th>
                                                <th>Puntos</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginated.map((client, i) => (
                                                <tr key={client.id} style={{ animationDelay: `${i * 0.03}s` }}>
                                                    <td>
                                                        <div className="cl-name-cell">
                                                            <div className="cl-avatar">{getInitials(client.name)}</div>
                                                            <div>
                                                                <div className="cl-name-val">{client.name}</div>
                                                                <div className="cl-email-val">{client.email}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ color: 'var(--text-2)' }}>@{client.nickname}</td>
                                                    <td>
                                                        <span className="cl-points-badge">
                                                            <IcoStar /> {client.points ?? 0}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="cl-btn-details"
                                                            onClick={() => handleClientDetails(client)}
                                                        >
                                                            Ver detalles <IcoArrow />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* ── CARDS — mobile ≤560px ── */}
                            <div className="cl-mobile-grid">
                                {filtered.length === 0 ? (
                                    <div className="cl-empty">
                                        <div className="cl-empty-icon">👤</div>
                                        <p className="cl-empty-title">
                                            {search ? 'Sin resultados' : 'Sin clientes registrados'}
                                        </p>
                                        <p className="cl-empty-sub">
                                            {search ? `No hay clientes que coincidan con "${search}".` : 'Aún no hay clientes en este negocio.'}
                                        </p>
                                    </div>
                                ) : paginated.map((client, i) => (
                                    <div
                                        className="cl-client-card"
                                        key={client.id}
                                        style={{ animationDelay: `${i * 0.04}s` }}
                                    >
                                        <div className="cl-client-card-avatar">{getInitials(client.name)}</div>
                                        <div className="cl-client-card-body">
                                            <div className="cl-client-card-name">{client.name}</div>
                                            <div className="cl-client-card-email">{client.email}</div>
                                        </div>
                                        <div className="cl-client-card-right">
                                            <span className="cl-points-badge">
                                                <IcoStar /> {client.points ?? 0}
                                            </span>
                                            <button
                                                className="cl-btn-details"
                                                onClick={() => handleClientDetails(client)}
                                            >
                                                Ver <IcoArrow />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* ── PAGINACIÓN ── */}
                            {filtered.length > 0 && (
                                <div className="cl-pagination">

                                    {/* info */}
                                    <div className="cl-pagination-info">
                                        Mostrando <span>{(safePage - 1) * pageSize + 1}–{Math.min(safePage * pageSize, filtered.length)}</span> de <span>{filtered.length}</span> clientes
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem', flexWrap: 'wrap' }}>

                                        {/* page size selector */}
                                        <div className="cl-page-size">
                                            <span>Mostrar</span>
                                            <select
                                                value={pageSize}
                                                onChange={e => setPageSize(Number(e.target.value))}
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                            </select>
                                            <span>por página</span>
                                        </div>

                                        {/* page buttons */}
                                        <div className="cl-pagination-controls">
                                            {/* first */}
                                            <button className="cl-pg-btn" onClick={() => setCurrentPage(1)} disabled={safePage === 1} title="Primera página">
                                                <IcoChevsL />
                                            </button>
                                            {/* prev */}
                                            <button className="cl-pg-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={safePage === 1} title="Anterior">
                                                <IcoChevL />
                                            </button>

                                            {/* numbered pages */}
                                            {pageNumbers.map((pg, i) =>
                                                pg === '…'
                                                    ? <span className="cl-pg-ellipsis" key={`e${i}`}>…</span>
                                                    : <button
                                                        key={pg}
                                                        className={`cl-pg-btn${safePage === pg ? ' active' : ''}`}
                                                        onClick={() => setCurrentPage(pg)}
                                                    >
                                                        {pg}
                                                    </button>
                                            )}

                                            {/* next */}
                                            <button className="cl-pg-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={safePage === totalPages} title="Siguiente">
                                                <IcoChevR />
                                            </button>
                                            {/* last */}
                                            <button className="cl-pg-btn" onClick={() => setCurrentPage(totalPages)} disabled={safePage === totalPages} title="Última página">
                                                <IcoChevsR />
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            )}

                        </div>

                    </div>

                    {/* ══ MODAL — historial de puntos ══ */}
                    {showModal && createPortal(
                        <div
                            className="cl-modal-overlay"
                            onClick={e => { if (e.target === e.currentTarget) setShowModal(false); }}
                        >
                            <div className="cl-modal-panel">

                                {/* header */}
                                <div className="cl-modal-header">
                                    <div className="cl-modal-avatar">
                                        {getInitials(selectedClient?.name)}
                                    </div>
                                    <div className="cl-modal-title">
                                        {selectedClient?.name}
                                        <span className="cl-modal-sub">Historial de puntos</span>
                                    </div>
                                    <button className="cl-modal-close" onClick={() => setShowModal(false)} aria-label="Cerrar">
                                        <IcoX />
                                    </button>
                                </div>

                                {/* client chips */}
                                <div className="cl-client-chips">
                                    <span className="cl-chip">
                                        <IcoMail />
                                        <span className="cl-chip-label">Email</span>
                                        <span className="cl-chip-val">{selectedClient?.email}</span>
                                    </span>
                                    <span className="cl-chip">
                                        <span className="cl-chip-label">Usuario</span>
                                        <span className="cl-chip-val">@{selectedClient?.nickname}</span>
                                    </span>
                                    <span className="cl-chip points">
                                        <IcoStar />
                                        <span className="cl-chip-val">{selectedClient?.points ?? 0} puntos</span>
                                    </span>
                                </div>

                                {/* transactions */}
                                <div className="cl-modal-body">
                                    <div className="cl-modal-section-label">
                                        <IcoHistory /> Transacciones ({clientTransactions.length})
                                    </div>

                                    {clientTransactions.length === 0 ? (
                                        <div className="cl-tx-empty">
                                            <div className="cl-tx-empty-icon">📋</div>
                                            <p className="cl-tx-empty-text">Sin transacciones registradas.</p>
                                        </div>
                                    ) : (
                                        <div className="cl-tx-list">
                                            {clientTransactions.map((tx, i) => {
                                                const variant = txVariant(tx.type);
                                                return (
                                                    <div className="cl-tx-row" key={tx.id || i} style={{ animationDelay: `${i * 0.03}s` }}>

                                                        {/* icon */}
                                                        <div className={`cl-tx-icon ${variant}`}>
                                                            {variant === 'earn' && <IcoPlus />}
                                                            {variant === 'redeem' && <IcoMinus />}
                                                            {variant === 'other' && <IcoHistory />}
                                                        </div>

                                                        {/* body */}
                                                        <div className="cl-tx-body">
                                                            <div className="cl-tx-desc">{tx.description || '—'}</div>
                                                            <div className="cl-tx-meta">
                                                                <IcoClock />
                                                                {new Date(tx.createdAt).toLocaleString('es-PA', {
                                                                    day: '2-digit', month: 'short', year: 'numeric',
                                                                    hour: '2-digit', minute: '2-digit',
                                                                })}
                                                            </div>
                                                        </div>

                                                        {/* right */}
                                                        <div className="cl-tx-right">
                                                            <div className={`cl-tx-points ${variant}`}>
                                                                {variant === 'earn' ? '+' : variant === 'redeem' ? '−' : ''}{tx.points}
                                                            </div>
                                                            <div className="cl-tx-type">{tx.type}</div>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>

                                {/* footer */}
                                <div className="cl-modal-footer">
                                    <button className="cl-btn-close" onClick={() => setShowModal(false)}>
                                        Cerrar
                                    </button>
                                </div>

                            </div>
                        </div>,
                        document.body
                    )}


                </MainContent>
            </AppShell>

        </>
    );
};

export default Clients;